import { useEffect, useState } from 'react';

const GREETINGS = {
  morning: [
    'Good morning! Ready to dive into something new?',
    'Morning! What can we build together today?',
    'Good morning—want to get a head start on your tasks?',
  ],
  afternoon: [
    'Good afternoon! What should we tackle next?',
    'Hey there! Need help drafting, coding, or brainstorming?',
    "Afternoon! Let's keep the momentum going.",
  ],
  evening: [
    'Good evening! Want to wrap up or plan for tomorrow?',
    'Evening! I can summarize, draft, or research for you.',
    "You're back—what should we dig into tonight?",
  ],
  night: [
    "Late night session? I'm here to help.",
    "Burning the midnight oil? Let's get this done.",
    'Night owl mode—what can I help you with?',
  ],
};

const getTimeOfDay = (date = new Date()) => {
  const hour = date.getHours();

  if (hour >= 5 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 17) return 'afternoon';
  if (hour >= 17 && hour < 22) return 'evening';
  return 'night';
};

const pickGreetingSequential = (timeOfDay) => {
  const pool = GREETINGS[timeOfDay] || GREETINGS.afternoon;
  if (pool.length === 0) return 'What can I help with?';

  // Rotate through options per time-of-day using localStorage for variety across reloads
  const storageKey = `arrowai:greeting:${timeOfDay}`;
  try {
    const lastIndex = parseInt(localStorage.getItem(storageKey) || '-1', 10);
    const nextIndex = (Number.isNaN(lastIndex) ? 0 : (lastIndex + 1) % pool.length);
    localStorage.setItem(storageKey, String(nextIndex));
    return pool[nextIndex];
  } catch (err) {
    // localStorage might be unavailable (SSR/sandbox); fall back to random
    return pool[Math.floor(Math.random() * pool.length)];
  }
};

const useDynamicGreeting = (refreshKey) => {
  const [timeOfDay, setTimeOfDay] = useState(getTimeOfDay);
  const [greeting, setGreeting] = useState(() => pickGreetingSequential(getTimeOfDay()));

  useEffect(() => {
    const interval = setInterval(() => {
      const next = getTimeOfDay();
      setTimeOfDay((prev) => (prev === next ? prev : next));
    }, 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setGreeting(pickGreetingSequential(timeOfDay));
  }, [timeOfDay, refreshKey]);

  return { greeting, timeOfDay };
};

export default useDynamicGreeting;
